// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveySaveQuestionResultResponseModel {
    static getAttributeTypeMap() {
        return SurveySaveQuestionResultResponseModel.attributeTypeMap;
    }
}
SurveySaveQuestionResultResponseModel.discriminator = undefined;
SurveySaveQuestionResultResponseModel.attributeTypeMap = [
    {
        "name": "nextQuestionId",
        "baseName": "nextQuestionId",
        "type": "number"
    }
];
//# sourceMappingURL=surveySaveQuestionResultResponseModel.js.map